export default {
  input_origin: {
    DINHEIRO: 'Dinheiro',
    VEICULO: 'Veículo Semi-novo',
    OUTRO: 'Outra fonte',
  },
  payment_types: {
    CARNE: 'Carnê',
    DEBITO: 'Débito em conta',
  },
  build_types: {
    QUITADA: 'Quitada',
    FINANCIADA: 'Financiada',
    ALUGADA: 'Alugada',
    PARENTE: 'Com Parentes',
    FUNCIONAL: 'Funcional',
    TERCEIROS: 'Com Terceiros',
  },
  marital_status: {
    CASADO: 'Casado',
    SOLTEIRO: 'Solteiro',
    VIUVO: 'Viúvo',
    DIVORCIADO: 'Divorciado',
    VIVE_MARITALMENTE: 'Vive Maritalmente',
  },
  phone_types: {
    CELULAR: 'Celular',
    CONTATO: 'Contato',
    COMERCIAL: 'Comercial',
    RECADO: 'Recado',
    EMPRESA_ANTERIOR: 'Empresa Anterior',
    PRINCIPAL: 'Principal',
    RESIDENCIAL: 'Residencial',
  },
  address_types: {
    PRINCIPAL: 'Principal',
    ANTERIOR: 'Anterior',
    ALTERNATIVO: 'Alternativo',
    COMERCIAL: 'Comercial',
  },
  ocuppations: {
    AGROPECUARISTA: 'Agropecuarista',
    APOSENTADO_PENSIONISTA: 'Aposentado / Pensionista',
    ASSALARIADO: 'Assalariado',
    AUFERE_RENDIMENTOS_CAPITAL: 'Aufere rendimentos de capital/aluguéis',
    EMPRESARIO_SOCIO: 'Empresário / Sócio',
    ESPOLIO: 'Espólio',
    ESTUDANTE_BOLSISTA: 'Estudante / Bolsista',
    AUTONOMO: 'Autônomo',
    PROFESSIONAL_LIBERAL: 'Profissional Liberal',
    PROFESSIONAL_LIBERAL_AUTONOMO: 'Autonomo / Profissional Liberal',
    SERV_PUB_ADM: 'Servidor Público Administrativo',
    SERV_PUB_AUTARQUIA: 'Servidor Público Autarquia',
  },
  professions: {
    APOSENTADO: 'Aposentado',
  },
  attachment_types: {
    FAT: {
      name: 'Comprovante de Faturamento',
      type: 'FAT',
    },
    CNPJ: {
      name: 'Cartão CNPJ',
      type: 'CNPJ',
    },
    CS: {
      name: 'Contrato social',
      type: 'CS',
    },
  },
  person_attachment_types: {
    RG_FRONT: {
      name: 'Carteira de Identidade (RG)',
      type: 'RGF',
    },
    RG_BACK: {
      name: 'Carteira de Identidade (RG, verso)',
      type: 'RGV',
    },
    CNH: {
      name: 'Carteira de Habilitação',
      type: 'CNH',
    },
    CTPS: {
      name: 'Carteira de Trabalho',
      type: 'CTPS',
    },
    ADDRESS: {
      name: 'Comprovante de Endereço',
      type: 'END',
    },
    INCOME: {
      name: 'Comprovante de Renda',
      type: 'HLT',
    },
  },
};
